<template>
  <div>
    <!-- 24.5.17 功能按钮 dxm -->
    <el-row type="flex" class="button-wrap container" justify="space-between">
      <el-col
        :span="7"
        v-for="(item, index) in buttonList"
        :key="index"
        style="display: flex; justify-content: center"
      >
        <div class="button-list" @click="changebtn(item.path)">
          <img class="button-icon de-icon" :src="item.icon" alt="" />
          <img class="button-icon act-icon" :src="item.active_icon" alt="" />
          <span>{{ langSet == "cn" ? item.title : item.en_title }}</span>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      :close-on-click-modal="false"
      class="dialog"
      :visible.sync="dialogVisible"
    >
      <img class="dialog_img" src="../../../assets/jqqd.jpg" />
      <div class="dialog_txt">
        {{ langSet == "cn" ? "敬请期待" : "Stay Tuned" }}
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      langSet: "",
      buttonList: [
        {
          icon: require("../../../assets/button_icon1.png"),
          active_icon: require("../../../assets/button_active1.png"),
          // 2025.09.19修改文案：观众报名 -> 展商报名 李晨
          title: "展商报名",
          en_title: "Exhibitor Registration",
          path: "apply",
        },
          // 暂时隐藏 2025年12月30日11:55:05 zfx ljj

        // {
        //   icon: require("../../../assets/button_icon2.png"),
        //   active_icon: require("../../../assets/button_active2.png"),
        //   // 2025.09.19修改文案：酒店预定 -> 2025会刊 李晨
        //   title: "2025会刊", //展商入口
        //   en_title: "2025 Proceedings",
        //   path: "https://www.bceia.cn/uploads/file/20250903/20250903173735589a35030.pdf",
        // },
        // {
        //   icon: require("../../../assets/button_icon3.png"),
        //   active_icon: require("../../../assets/button_active3.png"),
        //   // 2025.09.19修改文案：展商登录 -> 2025现场风采 李晨
        //   title: "2025现场风采",
        //   en_title: "2025 Expo Live Moments",
        //   // path: "service",
        //   path: "https://live.photoplus.cn/live/63252383?code=051po4ml2FYEkg4ldbml25snIP1po4m9&state=STATE#/list",
        // },
      ],
      dialogVisible: false,
    };
  },
  mounted() {
    this.langSet = localStorage.getItem("languageSet") || "cn";
  },
  methods: {
    changebtn(path) {
      if (path) {
        if (path.indexOf("https") != -1) {
          window.open(path, "_blank");
        } else if (path == "apply") {
          //25.6.27 观众报名链接替换 dxm
          // window.open(
          //   this.langSet == "cn"
          //     ? "https://t2.eainfor.com/T/w/129_509"
          //     : "https://t2.eainfor.com/T/pe/132_508",
          //   "_blank"
          // );
          // 2025.09.19 观众报名变为展商报名
          this.$router.push({
            name: "apply",
          });
        } else {
          this.$router.push({
            name: path,
          });
        }
      } else {
        this.dialogVisible = true;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.dialog {
  width: 350px;
  height: 288px;
  background: #ffffff;
  border-radius: 12px;
  margin: auto;
  display: flex;
}
.dialog_img {
  width: 151px;
  height: 160px;
}
.dialog_txt {
  margin-top: 40px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 18px;
  color: #333333;
}
.button-wrap {
  //隐藏两个后居中 2025年12月30日12:00:29
  display: flex;
  justify-content: center;

  // width: 1180px;
  margin-top: -152px;
  margin-bottom: 45px;
  position: relative;
  z-index: 9;
  .button-list {
    width: 300px;
    height: 79px;
    background: rgba(255, 255, 255, 0.9);
    border-radius: 15px;
    backdrop-filter: blur(10px);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #1c1c1e;
    font-size: 18px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s;
    .button-icon {
      width: 40px;
      margin-right: 20px;
      display: none;
    }
    .de-icon {
      display: block;
    }
    &:hover {
      color: #fff;
      background: linear-gradient(334deg, #233889 0%, #14a6fb 100%);
      .de-icon {
        display: none;
      }
      .act-icon {
        display: block;
      }
    }
  }
}
// 移动端
@media only screen and (max-width: 1280px) {
  .button-wrap {
    margin-top: -105px;
    margin-bottom: 20px;
    .button-list {
      height: 70px;
    }
  }
}
// 移动端
@media only screen and (max-width: 1000px) {
  .button-wrap {
    margin-top: -88px;
    margin-bottom: 20px;
    .button-list {
      height: 70px;
    }
  }
}
// 移动端
@media only screen and (max-width: 768px) {
  .dialog {
    width: 250px;
    height: 200px;
  }
  .dialog_img {
    width: 91px;
    height: 100px;
  }
  .dialog_txt {
    font-size: 14px;
    margin-top: 20px;
  }
  .button-wrap {
    margin-top: -55px;
    margin-bottom: 20px;
    .button-list {
      height: 35px;
      font-size: 10px;
      border-radius: 5px;
      span {
        display: inline-block;
        width: 70px;
      }
      .button-icon {
        width: 14px;
        margin-right: 10px;
        margin-left: 5px;
      }
    }
  }
}
// 移动端
@media only screen and (max-width: 484px) {
  .dialog {
    width: 250px;
    height: 200px;
  }
  .dialog_img {
    width: 91px;
    height: 100px;
  }
  .dialog_txt {
    font-size: 14px;
    margin-top: 20px;
  }
  .button-wrap {
    margin-top: -44px;
    margin-bottom: 20px;
    .button-list {
      height: 30px;
      font-size: 10px;
      border-radius: 5px;
      span {
        display: inline-block;
        width: 70px;
      }
      .button-icon {
        width: 14px;
        margin-right: 10px;
        margin-left: 5px;
      }
    }
  }
}
</style>
<style lang="scss">
.dialog .el-dialog__header {
  padding: 0;
}
.dialog .el-dialog {
  width: 100%;
  margin-top: 0 !important;
  box-shadow: initial !important;
}
.dialog .el-dialog__body {
  flex-direction: column;
  display: flex;
  align-items: center;
}
</style>